// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1EFgG","label":"Radio_label__39PTm","checkMark":"Radio_checkMark__2YB3u","disabled":"Radio_disabled__3s5eH"};